import { useRef } from "react";
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";

// Gentle parallax: media drifts slightly slower than scroll. Self-contained + stable.
export default function Parallax({ children, strength = 70, className = "" }) {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], [-strength, strength]);

  return (
    <div ref={ref} className={`absolute inset-0 overflow-hidden ${className}`}>
      <motion.div
        style={reduce ? undefined : { y }}
        className="absolute inset-x-0 -top-[14%] h-[128%]"
      >
        {children}
      </motion.div>
    </div>
  );
}
